import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const cashflowRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/cashflow",
  component: lazyRouteComponent(() => import("./cashflow.page.js"), "CashflowPage"),
});
